/**
 * @generated SignedSource<<b4821ecb27d821177223ee99c5bb5845>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventMembersFragment$data = {
  readonly canReadAgreement: boolean;
  readonly id: string;
  readonly members: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"EventMembersEventMembershipFragment">;
      };
    }>;
  };
  readonly viewerCanEdit: boolean;
  readonly viewerCanEditMembers: boolean;
  readonly viewerCanTransferOwnership: boolean;
  readonly " $fragmentType": "EventMembersFragment";
};
export type EventMembersFragment$key = {
  readonly " $data"?: EventMembersFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventMembersFragment">;
};

import EventMembersFragmentPaginationQuery_graphql from './EventMembersFragmentPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "members"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": EventMembersFragmentPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "EventMembersFragment",
  "selections": [
    (v1/*: any*/),
    {
      "alias": "viewerCanEdit",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "UPDATE_EVENT"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"UPDATE_EVENT\")"
    },
    {
      "alias": "viewerCanEditMembers",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "ADD_EVENT_MEMBER"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"ADD_EVENT_MEMBER\")"
    },
    {
      "alias": "viewerCanTransferOwnership",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "TRANSFER_EVENT_OWNERSHIP"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"TRANSFER_EVENT_OWNERSHIP\")"
    },
    {
      "alias": "canReadAgreement",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "READ_COMPETITION_RULE_AGREEMENT"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"READ_COMPETITION_RULE_AGREEMENT\")"
    },
    {
      "alias": "members",
      "args": null,
      "concreteType": "EventMembershipConnection",
      "kind": "LinkedField",
      "name": "__EventMembersFragment_members_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventMembershipEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventMembership",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "EventMembersEventMembershipFragment"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "756570e215c5cb75ae8c7c1d71978909";

export default node;
